import { DragEvent } from 'react';

/**
 * True when a native row-drag actually started on top of a SimpleBar scrollbar instead of on the row
 * content. The projects table marks whole rows + cells `draggable` (see `useDraggableRows`) and uses
 * SimpleBar with `autoHide={false}`, so the always-visible scrollbars overlay the table edges. The
 * horizontal track sits at the bottom, overlapping the LAST row — grabbing it begins dragging the last
 * project. We detect it geometrically: if the drag's pointer coordinates fall inside any SimpleBar
 * track rect, the caller should `preventDefault()` and bail so the scrollbar scrolls normally.
 *
 * Geometric (not target-based) on purpose: the element that receives the dragstart can be the cell
 * under the scrollbar, so checking `e.target` is unreliable — the pointer position is not.
 */
export const isDragStartOnScrollbar = (e: DragEvent): boolean => {
  const root = (e.target as HTMLElement).closest('[data-simplebar]');
  if (!root) return false;

  const tracks = Array.from(root.querySelectorAll<HTMLElement>('.simplebar-track'));
  return tracks.some((track) => {
    const r = track.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  });
};
